import { cx } from '@linaria/core';
import { mdiCloseCircle } from '@mdi/js';
import Icon from '@mdi/react';
import { HTMLAttributes, MouseEvent, MouseEventHandler, ReactNode } from 'react';
import "./Chip.linaria.module.css!=!./Chip?./Chip.linaria.module.css?css=H4sIAAAAAAAAA22Uy5LbIBBF9/mK2aScqRpcQuMnWWWXTb6BQoBQywgwoJep/HvK8ciWPLO8XfdcaLqlNYsNPQaK8W7M2CkJCE6zkYDRYCQqtRx+/v22vroqiqudrdvLUiWmQRkEUTaBcGmi9BNR8gXykKluQ4RyRNyaKE184vbvtA0dHJtU2AEFuIBRpLBeSI8Ke79Q/U6xDWebd6lhA+pBxIrgLPs+GWROcQd7yftUSVBVJO+5u+PbmsqBx0ORPqI9E9AGgncPT9dRfD5yri6pryBKFBzjkhjbe+YmUzFQbPuTqIsnmUprIipZA3okqz/WxCC9Z3H1tvotdScjcLZ6W/3ywPTqLTATUJAeyimYH2ivYSf5Ut1iA1wkydYHnG+9bCYkF9SNYdN3S5UKxk/K29YIxK22nnTM/0BoVtbXB0LKsxHlr1PcsaZRn2SmE299sJ44C/NJ5YLiOj/UQ/4kPx8YPTPBMS9NnOj3kmLnNg6rjxEQ7IaXYDWIl9v9BARWaCmQ8nJ8nc81clVv1TTXfPOYGc6qqsm3tIwKdP5F6WXNK3BIs0Lq5JgQYBTSsozk8EjRAm94Mw9ZVL7M8P/vMg85UVz2g+nkk1wei2dbqfUS0Z+Q2ylz5hQo3nbnvvfJdtKX2vakAiGkmRzhTLHOA4guRTlEdLdJrcEFCPddLigIV6rNUqXrjwCFyoM5kWwyqwsda5eV1VKlhnkF5tYbmn1NVUbxZsz3Y/skJ+LW2vZB7DXFQ1cPFqf52t7X4trMfS3woT2rGiguQ267nlTXLhdckNwawfx4B/8BnVIisAAFAAA="
const chipStyles = "atm_9s_116y0ak atm_h_1h6ojuz atm_fc_1h6ojuz atm_73_usvi9m atm_j3_1osqo2v atm_e2_1vi7ecw atm_5j_exct8b atm_vv_1q9ccgz atm_bx_1owkdjb atm_c8_wli6ec atm_2d_pys4wv";
const clickableStyles = "atm_9j_tlke0l";
const outlinedStyles = "atm_2d_1j28jx2 atm_3f_1pp4p1g";
const smallStyles = "atm_e2_1tcgj5g atm_10hhm25_ftgil2 atm_ld14cm_ftgil2";
const labelStyles = "atm_lk_1fwxnve atm_ll_1fwxnve atm_ks_15vqwwr atm_sq_1l2sidv atm_vv_1q9ccgz";
const deleteStyles = "atm_9j_tlke0l atm_bb_idpfg4 atm_gz_yjp0fh atm_h0_14y27yu atm_7l_1xvjxo1 atm_18uqgji_1fs2ovw";
interface ChipProps extends Omit<HTMLAttributes<HTMLDivElement>, 'onClick' | 'className'> {
  label: ReactNode;
  className?: string;
  onClick?: MouseEventHandler<HTMLDivElement>;
  onDelete?: (event: MouseEvent<Element>) => void;
  outlined?: boolean;
  small?: boolean;
  'data-testid'?: string;
}
const Chip = ({
  label,
  className,
  onClick,
  onDelete,
  outlined,
  small,
  ...rest
}: ChipProps) => <div onClick={onClick} className={cx(chipStyles, onClick && clickableStyles, outlined && outlinedStyles, small && smallStyles, className)} {...rest}>
        <span className={cx('chip-label', labelStyles)}>{label}</span>
        {onDelete && <Icon path={mdiCloseCircle} size="22px" className={cx('chip-delete', deleteStyles)} onClick={event => {
    event.stopPropagation();
    onDelete(event);
  }} />}
    </div>;
export default Chip;